// extracted by mini-css-extract-plugin
export default {"bg":"Footer_bg__rPdG4","pad":"Footer_pad__qdT1q","left":"Footer_left__kZhsc","right":"Footer_right__ukp1z"};